import React from 'react';
import { useSelector } from 'react-redux';
import { useFirestore, useFirestoreConnect } from 'react-redux-firebase';

import BlockList from '../Blocks/BlockList';
import Icon from '../ui/Icon';

import styles from './Content.module.scss';

function Starred(props) {

  const auth = useSelector(state => state.firebase.auth);
  const uid = auth.uid;
  const blocks = useSelector(state => state.firestore.ordered[`blocks-starred`]) || [];

  const sortedBlocks = blocks.slice();
  sortedBlocks.sort((a, b) => {
    return (b.index || 0) - (a.index || 0);
  });

  useFirestoreConnect([
    {
      collection: 'blocks',
      where: [
        ['owner', '==', uid],
        ['isStarred', '==', true],
      ],
      storeAs: `blocks-starred`
    }
  ]);

  return (
    <div className={styles.innerContainer}>

      {
        sortedBlocks ? (
          <>
            <div className={styles.title}>
              <Icon
                className={styles.icon}
                id="star"
                size={40}
              />
              <div className={styles.name}>Starred</div>
            </div>
            <div className={styles.blocks}>
              <BlockList
                blocks={sortedBlocks}
                owner="list"
                section="starred"
              />
            </div>
          </>
        ) : (
          <div>Loading…</div>
        )
      }

    </div>
  );

}

export default Starred;
